import { useState } from "react";
import sold from "../../components/staticsLogos/SoldOut.png";

const TicketIcon = () => (
  <svg
    width="60"
    height="73"
    viewBox="0 0 90 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M82.8231 45.1603V35.2545C82.8231 33.4202 81.3555 31.861 79.4296 31.861L67.9646 31.8604C67.781 32.7778 66.9557 33.511 65.9468 33.511C64.9378 33.511 64.1125 32.7771 63.9289 31.8604H3.39349C1.55925 31.8604 0 33.328 0 35.2538V45.1596C3.94365 45.1596 7.15419 48.3702 7.15419 52.4052C7.15419 56.3489 3.94365 59.6508 0 59.6508V69.5566C0 71.3908 1.46767 72.9501 3.39349 72.9501H63.9289C64.1125 72.0326 64.9379 71.2994 65.9468 71.2994C66.9557 71.2994 67.781 72.0333 67.9646 72.9501H79.4296C81.2639 72.9501 82.8231 71.4824 82.8231 69.5566V59.5599C78.8795 59.5599 75.669 56.3494 75.669 52.3143C75.5775 48.37 78.7873 45.1601 82.8231 45.1601V45.1603ZM65.9466 69.833C64.8462 69.833 63.9287 68.9156 63.9287 67.8152C63.9287 66.7148 64.8462 65.7974 65.9466 65.7974C67.047 65.7974 67.9644 66.7148 67.9644 67.8152C67.9644 68.9163 67.1391 69.833 65.9466 69.833ZM65.9466 64.6969C64.8462 64.6969 63.9287 63.7794 63.9287 62.679C63.9287 61.5786 64.8462 60.6612 65.9466 60.6612C67.047 60.6612 67.9644 61.5786 67.9644 62.679C67.9644 63.7801 67.1391 64.6969 65.9466 64.6969ZM65.9466 59.4691C64.8462 59.4691 63.9287 58.5517 63.9287 57.4513C63.9287 56.3509 64.8462 55.4334 65.9466 55.4334C67.047 55.4334 67.9644 56.3509 67.9644 57.4513C67.9644 58.5517 67.1391 59.4691 65.9466 59.4691ZM65.9466 54.333C64.8462 54.333 63.9287 53.4155 63.9287 52.3151C63.9287 51.2147 64.8462 50.2973 65.9466 50.2973C67.047 50.2973 67.9644 51.2147 67.9644 52.3151C67.9644 53.4155 67.1391 54.333 65.9466 54.333ZM65.9466 49.1046C64.8462 49.1046 63.9287 48.1871 63.9287 47.0867C63.9287 45.9863 64.8462 45.0689 65.9466 45.0689C67.047 45.0689 67.9644 45.9863 67.9644 47.0867C67.9644 48.1871 67.1391 49.1046 65.9466 49.1046ZM65.9466 43.9684C64.8462 43.9684 63.9287 43.0509 63.9287 41.9506C63.9287 40.8502 64.8462 39.9327 65.9466 39.9327C67.047 39.9327 67.9644 40.8502 67.9644 41.9506C68.0559 43.051 67.1391 43.9684 65.9466 43.9684ZM65.9466 38.74C64.8462 38.74 63.9287 37.8226 63.9287 36.7222C63.9287 35.6218 64.8462 34.7043 65.9466 34.7043C67.047 34.7043 67.9644 35.6218 67.9644 36.7222C68.0559 37.8233 67.1391 38.74 65.9466 38.74Z"
      fill="url(#paint0_linear_63_7921)"
    />
    <path
      d="M89.7908 34.0618L86.3052 24.8898C82.5445 26.2653 78.4173 24.3395 77.0416 20.6703C75.6661 16.9096 77.5004 12.7823 81.2611 11.4067L77.7756 2.14312C77.1332 0.400265 75.2074 -0.425055 73.4647 0.21666L62.7334 4.25252C62.9171 5.16998 62.3668 6.17897 61.4494 6.54553C60.5319 6.91213 59.5229 6.54553 58.9728 5.72019L2.2896 26.9076C0.546749 27.5499 -0.278571 29.4758 0.363144 31.2184L0.729748 32.1359C1.46359 31.4936 2.4726 31.0355 3.57292 31.0355H79.6091C81.9936 31.0355 83.8285 32.9619 83.8285 35.2549V39.9325L87.9558 38.3733C89.5162 37.7303 90.4331 35.8045 89.7914 34.0618L89.7908 34.0618ZM60.532 10.0311C60.1654 8.93062 60.6235 7.82961 61.7245 7.3715C62.825 7.0049 63.926 7.46299 64.3841 8.56406C64.7507 9.66451 64.2926 10.7655 63.1915 11.2236C62.1826 11.6817 60.9906 11.1315 60.532 10.0311ZM62.3662 14.8922C61.9996 13.7918 62.4577 12.6908 63.5588 12.2327C64.6592 11.8661 65.7602 12.3242 66.2184 13.4252C66.585 14.5257 66.1269 15.6267 65.0258 16.0848C63.9253 16.5429 62.8248 15.9927 62.3662 14.8922ZM64.2005 19.7534C63.8339 18.653 64.292 17.552 65.393 17.0939C66.4935 16.7273 67.5945 17.1853 68.0526 18.2864C68.4192 19.3869 67.9611 20.4879 66.86 20.946C65.7596 21.4041 64.5677 20.8539 64.2005 19.7534ZM66.0347 24.6146C65.6681 23.5142 66.1262 22.4131 67.2273 21.955C68.3277 21.5884 69.4287 22.0465 69.8868 23.1476C70.3456 24.248 69.7953 25.349 68.6943 25.8072C67.5945 26.2653 66.4019 25.715 66.0347 24.6146ZM70.5292 30.6683C69.4287 31.0349 68.3277 30.5768 67.8696 29.4757C67.503 28.3753 67.9611 27.2743 69.0622 26.8162C70.1626 26.4496 71.2636 26.9077 71.7217 28.0087C72.0883 29.1092 71.5381 30.3011 70.5292 30.6683Z"
      fill="url(#paint1_linear_63_7921)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_63_7921"
        x1="1.39786"
        y1="31.8604"
        x2="85.3078"
        y2="37.7901"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7722" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_63_7921"
        x1="1.66297"
        y1="4.32382e-06"
        x2="92.5827"
        y2="7.17232"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7722" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

const CheckMark = () => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 0C17.9313 0 0 17.9304 0 40C0 62.0697 17.9304 80 40 80C62.0697 80 80 62.0697 80 40C80 17.9304 62.0697 0 40 0ZM33.3293 58.0437L20.9833 45.6978L25.6866 40.9945L33.3293 48.6372L57.6379 24.3067L62.3412 29.01L33.3293 58.0437Z"
      fill="url(#paint0_linear_63_7944)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_63_7944"
        x1="1.35021"
        y1="8.66226e-06"
        x2="82.7047"
        y2="2.85223"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7722" />
        <stop offset="1" stopColor="#FFB800" />
      </linearGradient>
    </defs>
  </svg>
);

const OTHER_INFO_MAX_LENGTH = 200;
interface IProps {
  service: Service;
}
export default function Ticket({ service }: IProps) {
  const [isSelected, setIsSelected] = useState(false);
  const [otherInfoMaxLength, setOtherInfoMaxLength] = useState(
    OTHER_INFO_MAX_LENGTH,
  );
  const loadMore = () =>
    setOtherInfoMaxLength((prev) => prev + OTHER_INFO_MAX_LENGTH);

  return (
    <div className="d-flex align-items-start justify-content-between mb-5 sm:mb-5">
      <div className="d-flex gap-5 md:gap-8">
        {service?.available > 0 ? (
          <div>
            {service?.image ? (
              <img
                src={service?.image}
                alt={service?.label}
                width={60}
                height={70}
                style={{ objectFit: "contain" }}
              />
            ) : (
              <TicketIcon />
            )}{" "}
          </div>
        ) : (
          <img
            src={sold}
            alt={""}
            width={60}
            height={80}
            style={{ objectFit: "contain" }}
          />
        )}

        <div>
          <p className="fw-semibold font-lg text-uppercase mb-0">
            {service?.label}
          </p>
          <p className="text-danger mb-0">{service?.startingPrice} DH</p>
          {service?.otherInfo && (
            <p className="text-gray-400 mt-2">
              {service?.otherInfo.substring(0, otherInfoMaxLength)}
              {service.otherInfo.length > otherInfoMaxLength && (
                <button
                  className="btn outline-none text-danger ms-1"
                  onClick={loadMore}
                >
                  voir plus
                </button>
              )}
            </p>
          )}
        </div>
      </div>

      {service?.available > 0 ? (
        <div>
          {isSelected ? (
            <button
              className="border-0 bg-transparent"
              onClick={() => setIsSelected(false)}
            >
              <CheckMark />
            </button>
          ) : (
            <div
              onClick={() => setIsSelected(true)}
              className="bg-gradient-primary shadow-md  cursor-pointer select-btn-active shadow-sm"
            >
              <div className="bg-white d-flex align-items-center justify-content-center rounded-xs w-full h-full">
                <p className="text-danger mb-0">Select +</p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="cursor-not-allowed rounded-xs select-btn-notactive shadow-sm">
          <div className="bg-white d-flex align-items-center justify-content-center rounded-xs w-full h-full">
            <p className="text-black-50 mb-0">Select +</p>
          </div>
        </div>
      )}
    </div>
  );
}
